<template>
  <div class="product-head">
    <template v-if="tags.length > 0">
      <div class="product-head__top">
        <div class="product-head__tags">
          <template v-if="tags.length > 0">
            <div
              v-for="(tag, index) in tags"
              :key="`product-head__tag-${index}`"
              class="product-head__tag"
              :class="{'--icon': Boolean(tag.iconLink)}"
              :style="`background: ${tag.bgColor}; color: ${tag.labelColor}`"
            >
              <div class="tooltip">
                <div class="tooltip__item">
                  <span v-if="tag.label" v-html="tag.label"/>
                  <img v-if="tag.iconLink" :src="tag.iconLink" width="20px" height="20px" alt=""/>
                </div>
                <div v-if="tag.tooltip" class="tooltip__hover">
                  <span v-html="tag.tooltip"/>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div
          class="product-head__wish"
          @click="changeWish"
        >
          <img
            v-if="!isWish"
            src="~/assets/img/svg/common/heart.svg"
            alt=""
          />
          <img
            v-if="isWish"
            src="~/assets/img/svg/common/heart-fill.svg"
            alt=""
          />
        </div>
      </div>
      <div class="product-head__row-name-price">
        <h1 class="product-head__name h3 semibold">{{ product.name }}</h1>
        <div v-if="isShowPrice" class="product-head__prices">
          <div class="--new">{{ priceProduct }}</div>
          <div v-if="oldPriceProduct" class="--old">{{ oldPriceProduct }}</div>
        </div>
      </div>
    </template>
    <template v-if="tags.length <= 0">
      <div class="product-head__top --no-tags">
        <div class="product-head__row-name-price">
          <h1 class="product-head__name h3 semibold">{{ product.name }}</h1>
          <div
            class="product-head__wish"
            @click="changeWish"
          >
            <img
              v-if="!isWish"
              src="~/assets/img/svg/common/heart.svg"
              alt=""
            />
            <img
              v-if="isWish"
              src="~/assets/img/svg/common/heart-fill.svg"
              alt=""
            />
          </div>
          <div v-if="isShowPrice" class="product-head__prices">
            <div class="--new">{{ priceProduct }}</div>
            <div v-if="oldPriceProduct" class="--old">{{ oldPriceProduct }}</div>
          </div>
        </div>
      </div>
    </template>
    <div
      v-if="false"
    >
      <div
        v-if="collections.length > 0"
        class="product-head__collection h6"
      >
        <a @click="scrollToCollections">Товар в коллекциях</a>
      </div>
    </div>
    <div
      v-if="$viewport.isGreaterOrEquals('lg')"
      class="products-head__bottom-buttons"
    >
      <WishBtnWithText :product-id="+product.id" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import useSitisWish from '#sitis/composables/useSitisWish';
import { scrollToElement } from '~/utils/scrollToElement';
import getDiscountLabel from '~/utils/getDiscountLabel';
import { getCharacteristicFromFull } from '~/utils/getCharacteristic';
import getPromotionsProduct from '~/utils/getPromotionsProduct';

const WishBtnWithText = defineAsyncComponent(() => import('~/components/widget/WishBtnWithText.vue'))

const wishList = useSitisWish();
const props = defineProps({
  product: {
    type: Object as any,
    default: () => {
    }
  }
});
const {
  $numberFormat
} = useNuxtApp();

const isWish = computed(() => {
  return wishList.isInWish(props.product?.id);
});
const changeWish = async () => {
  if (isWish.value) {
    await wishList.removeItemFromWishList(props.product?.id);
  } else {
    await wishList.addToWishList({ id: props.product?.id });
  }
};

const tags = computed(() => {
  const _items = getPromotionsProduct(props.product);
  return _items
});
const collections = computed(() => {
  return (props.product?.productSetParents || [])
    .map((item: any) => {
      return {
        path: item.url,
        label: item.name
      };
    });
});

const scrollToCollections = () => {
  scrollToElement('#collections');
};

const isShowPrice = computed(() => {
  if (props?.product?.totalBonusValue) {
    return false
  }
  return !Boolean(props?.product?.hasOptions)
});
const priceProduct = computed(() => {
  return `${$numberFormat(props.product.price)} ₽`;
});
const oldPriceProduct = computed(() => {
  if (!props.product.oldPrice || props.product.oldPrice <= props.product.price) {
    return null;
  }
  return `${$numberFormat(props.product.oldPrice)} ₽`;
});
</script>

<style lang="scss" scoped>
.product-head {
	width: 100%;
  position: relative;
  z-index: 1;
}

.product-head__top {
	display: flex;
	margin-bottom: 24px;

  &.--no-tags {
    .product-head__row-name-price {
      margin-top: 3.5px;
    }
    .product-head__name {
      flex: 1;
      padding-right: 20px;
      box-sizing: border-box;
    }
  }
}

.product-head__tags {
	flex: 1;
	display: flex;
	flex-wrap: wrap;
	margin-top: -10px;
	margin-left: -10px;

	& > div {
		margin-top: 10px;
		margin-left: 10px;
	}
}

.product-head__row-name-price {
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: 10px;

  .product-head__name {
    padding-top: 6px;
  }
}

.product-head__collection {
	margin-top: 5px;
	color: #989898;

	a {
		border-bottom: 1px solid;
		transition: all 0.3s;
		cursor: pointer;

		&:hover {
			border-bottom-color: transparent;
		}
	}
}

.product-head__tag {
  display: flex;
  align-items: center;
	padding: 8px 24px;
  height: 40px;
	box-sizing: border-box;
	border-radius: 10px;
	background-color: #D3E6C6;
	color: #252525;
	font-size: 12px;
	font-weight: 600;

  &.--icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    padding: 0;

    img {
      width: auto;
      max-width: 100%;
      height: auto;
      max-height: 100%;
    }
  }
  .tooltip__hover {
    top: 100%;
    right: 0;
    border-radius: 15px 0 15px 15px;
    transform: translateY(20px) translateX(10px);
    bottom: initial;
    max-width: 320px;
    z-index: 10;
    &:after {
      bottom: 100%;
      transform: translateY(10px);
    }
  }
}

.product-head__wish {
	display: none;
	align-items: center;
	justify-content: center;
	width: 38px;
	height: 38px;
	cursor: pointer;
	background-color: #F4F3F1;
	border-radius: 10px;
	user-select: none;

	img {
		filter: invert(64%) sepia(4%) saturate(5675%) hue-rotate(314deg) brightness(106%) contrast(86%);
		transition: all 0.3s;
	}

	&:hover {
		img {
			transform: scale(1.1);
		}
	}
}

.product-head__prices {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-left: auto;

  .--new {
    font-size: 32px;
    font-weight: 600;
    line-height: 130%;
    color: #000000;
    white-space: nowrap;
  }
  .--old {
    font-size: 12px;
    font-weight: 500;
    line-height: 130%;
    color: #B8B8B8;
    white-space: nowrap;
    text-decoration: line-through;
  }
}
.products-head__bottom-buttons {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  padding-top: 20px;
}
@media (max-width: 1023px) {
	.product-head {
		margin-top: 24px;
	}
	.product-head__top {
		gap: 10px;
	}
	.product-head__tags {
		gap: 10px;
		margin-top: 0;
		margin-left: 0;

		& > div {
			margin-top: 0;
			margin-left: 0;
		}
	}
	.product-head__tag {
		padding: 6.5px 24px;
		font-weight: 500;

    .tooltip__hover {
      max-width: 200px;
      left: 0;
      transform: translateX(0) translateY(25px);
      border-radius: 15px;
      border-top-left-radius: 0;

      &:after {
        transform: translateX(0) translateY(10px);
        left: 0; right: initial;
        border-left: 10px solid #F4F3F1;
        border-right: initial;
      }
    }
	}
  .product-head__row-name-price {
    .product-head__name {
      font-size: 28px;
      line-height: 125%;
      padding-top: 0;
    }
  }
	.product-head__wish {
    display: flex;
		width: 37px;
		height: 37px;
	}
  .product-head__prices {
    display: none;
  }
}
</style>
